import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { PageNavBar } from '../../cmps/nav-header/page-nav-bar'

export const CompanyPage: React.FC = () => {
  const location = useLocation()

  if (location.pathname === '/companies') {
    return <Navigate to={`/companies/audit-controls${location.search}`} replace />
  }

  return <section className="database-page page-content-padding">
    <PageNavBar mainPage='company' />
    <Outlet />
  </section>
}
